import React, {Component, Fragment} from 'react'
import {Breadcrumb, Card, Icon, Row} from 'antd'
import style from './style.css'
import List from './List'
import useTitle from '../../../elements/Hooks/useTitle'

function Deposits(props) {
  useTitle('Deposits')
  return (
    <Fragment>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item>Deposits</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className={style.title}>
            <Icon type="home" style={{marginRight: 10, color: '#c90b7f'}} />
            Sales Deposits
          </h1>
          <p className={style.paragraph}>View and list client deposits.</p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <List {...props} />
      </Card>
    </Fragment>
  )
}

Deposits.propTypes = {}
Deposits.defaultProps = {}

export default Deposits
